import React from 'react';

const TONE = {
    primary: 'bg-primary-50  text-primary-700',
    success: 'bg-success-50  text-success-700',
    warning: 'bg-warning-50  text-warning-700',
    danger:  'bg-danger-50   text-danger-700',
    neutral: 'bg-neutral-100 text-neutral-700',
    accent:  'bg-accent-50   text-accent-700',
};

const Badge = ({ tone = 'neutral', children, dot = false, className = '' }) => (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full ${TONE[tone]} ${className}`}>
        {dot && <span className={`w-1.5 h-1.5 rounded-full ${
            tone === 'success' ? 'bg-success-500' :
            tone === 'warning' ? 'bg-warning-500' :
            tone === 'danger'  ? 'bg-danger-500'  :
            tone === 'primary' ? 'bg-primary-500' :
                                  'bg-neutral-400'
        }`} />}
        {children}
    </span>
);

export default Badge;
